import { render, staticRenderFns } from "./MemberStack.vue?vue&type=template&id=31045275&scoped=true"
import script from "./MemberStack.vue?vue&type=script&lang=js"
export * from "./MemberStack.vue?vue&type=script&lang=js"
import style0 from "./MemberStack.vue?vue&type=style&index=0&id=31045275&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31045275",
  null
  
)

export default component.exports